import { NotificationKey } from 'helpers/app.config';

/** Claves legacy con endpoints especializados en TicketApi (campanita). */
export const LEGACY_STATUS_NOTIFICATION_KEYS: ReadonlySet<string> = new Set([
  NotificationKey.TicketReviewPendingSerie,
  NotificationKey.ReviewPendingWarehouse,
  NotificationKey.ReviewScheduled
]);

export function isLegacyStatusNotificationKey(
  notificationKey: string | NotificationKey | undefined | null
): boolean {
  if (!notificationKey) return false;
  return LEGACY_STATUS_NOTIFICATION_KEYS.has(notificationKey);
}
